export const isDynamicImportError = (error: unknown): error is TypeError =>
  error instanceof TypeError &&
  error.message.includes('Failed to fetch dynamically imported module');
